<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getWeak } from '@/services/login';
export default{
  created(){
    this.getWeakFn()
  },
  methods:{
    async getWeakFn() {
      const res = await getWeak();
      if(res.code === 200){
        sessionStorage.setItem('weakPassword',JSON.stringify(res.data))
      }
    },
  }
}
</script>

<style lang="scss"></style>
